import { ia } from 'lib/helpers/utility';

export const getAddressDisplay = (address) => {
  if (address && typeof address === 'object' && !ia(address)) {
    return address?.fullAddress;
  }

  if (address && typeof address !== 'number') {
    return address;
  }

  return null;
};

const toTitleCaseIfUpper = (value) =>
  value && value === value.toUpperCase()
    ? value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
    : value;

const formatZip = (zip) => {
  const digits = String(zip ?? '').replace(/\D/g, '');
  return digits.length === 9 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : zip;
};

const getStateCode = (address) =>
  address?.addressState?.abbreviation ||
  (typeof address?.state === 'string' ? address.state : null);

export const formatCityState = (address) =>
  [toTitleCaseIfUpper(address?.city), getStateCode(address)].filter(Boolean).join(', ');

export const formatAddressLines = (address) => {
  if (!address) return [];
  const street = [
    address.address_ln_1 ?? address.address_1,
    address.address_ln_2 ?? address.address_2
  ]
    .filter(Boolean)
    .map(toTitleCaseIfUpper)
    .join(', ');
  const stateZip = [getStateCode(address), formatZip(address.zip ?? address.postal_code)]
    .filter(Boolean)
    .join(' ');
  const locality = [toTitleCaseIfUpper(address.city), stateZip].filter(Boolean).join(', ');
  return [street, locality].filter(Boolean);
};
